module.exports = __webpack_public_path__ + "static/company-visual-a9e500975b9001c07b0c08537fda3365.png";